<div class="bg-m0 flex select-none flex-col p-9">
  <div class="flex flex-col justify-start">
    <div
      data-cy="chartsReplaceColumnDialogTitle"
      class="text-s2 mt-5 text-left text-2xl font-semibold"
      >Replace Column</div
    >

    <div class="flex flex-col">
      <div class="ml-1 mt-9 flex flex-row items-center">
        <m-field-result
          class="h-5 w-5"
          [size]="2"
          [fieldClass]="currentField.fieldClass"
          [result]="currentField.result"
        ></m-field-result>

        <m-field-label
          [column]="currentField"
          class="ml-3 flex"
        ></m-field-label>
      </div>

      <div
        class="mt-6 flex min-w-[2px] max-w-[1000px] flex-grow select-none flex-row items-start items-center"
      >
        <form
          [formGroup]="addFieldForm"
          class="min-w-[2px] max-w-[800px] flex-grow"
        >
          <ng-select
            #columnFieldSelect
            [fixNgSelectBottom]="columnFieldSelect"
            data-cy="columnFieldSelect"
            class="charts-replace-column-select w-full min-w-[2px] text-base"
            [items]="matchFields"
            [clearable]="false"
            [searchable]="true"
            [searchFn]="searchFn"
            [(ngModel)]="newColumnFieldId"
            (change)="selectFieldChange()"
            (keyup.esc)="
              $event.stopImmediatePropagation(); columnFieldSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation(); columnFieldSelect.blur()
            "
            appendTo="body"
            placeholder="Select Field"
            formControlName="selectField"
            bindLabel="partLabel"
            bindValue="id"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="ml-1 flex flex-row items-center">
                <m-field-result
                  class="h-5 w-5"
                  [size]="2"
                  [fieldClass]="item.fieldClass"
                  [result]="item.result"
                ></m-field-result>

                <m-field-label
                  [column]="item"
                  class="ml-3 flex"
                ></m-field-label>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="ml-1 flex flex-row items-center">
                <m-field-result
                  class="h-5 w-5"
                  [size]="2"
                  [fieldClass]="item.fieldClass"
                  [result]="item.result"
                ></m-field-result>

                <m-field-label
                  [column]="item"
                  class="ml-3 flex"
                ></m-field-label>
              </div>
            </ng-template>
          </ng-select>
        </form>
      </div>
    </div>
  </div>

  <div class="mt-14 flex flex-row items-center">
    <ng-template #templateReplaceColumn>
      <div *ngIf="isFieldAlreadySelected === true"
        >This column is already selected</div
      >
    </ng-template>

    <div
      class="flex"
      [tpIsEnabled]="isFieldAlreadySelected === true"
      [tp]="templateReplaceColumn"
    >
      <button
        data-cy="chartsReplaceColumnDialogSaveButton"
        class="bg-m600 text-m0 w-28 select-none rounded py-3 text-base font-medium focus:outline-none"
        [ngClass]="{
          'bg-m600': isFieldAlreadySelected === false,
          'bg-s400 cursor-default': isFieldAlreadySelected === true
        }"
        type="button"
        (click)="save()"
        [disabled]="isFieldAlreadySelected === true"
        >Replace</button
      >
    </div>

    <button
      data-cy="chartsReplaceColumnDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
